<template>
    <div class="comline chartConfig_viewDP">
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">标记图形</span>
            <el-select v-model="scatter.symbol" placeholder="请选择标记图形"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in symbolList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">标记大小</span>
            <el-input v-model="scatter.symbolSize" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">标记颜色</span>
            <el-color-picker v-model="scatter.itemStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'line_config',
        components: {},
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                symbolList: [
                    {value: 'circle', label: '圆'},
                    {value: 'rect', label: '矩型'},
                    {value: 'roundRect', label: '圆矩型'},
                    {value: 'pin', label: '标记'},
                    {value: 'arrow', label: '箭头'},
                    {value: 'none', label: '空'},
                    {value: 'triangle', label: '三角形'},
                    {value: 'emptyCircle', label: '空心圆'},
                    {value: 'diamond', label: '菱形'}
                ],
                lineList:[
                    {value: 'solid', label: '实线'},
                    {value: 'dashed', label: '虚线'},
                    {value: 'dotted', label: '点线'},
                ]
            }
        },
        computed: {
            scatter() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params.scatter;
                }  else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params.scatter;
                }
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },

        destroyed() {

        }

    }
</script>

<style lang="less">
    .line_config {

    }
</style>